export function degreeToRad(deg: number): number {
  return (deg / 180) * Math.PI;
}
